'use client';

import { createTheme, ThemeOptions } from '@mui/material/styles';
import responsiveBaseTheme from '@/styles/brands/base';
import deepmerge from '@mui/utils/deepmerge';

const ir = createTheme(
	deepmerge(responsiveBaseTheme, {
		palette: {
			primary: {
				main: 'rgba(238, 42, 36, 1)', //#EE2A24
			},
			secondary: {
				main: 'rgba(238, 42, 36, 1)', //#EE2A24
			},
			accent: {
				main: 'rgba(254, 245, 245, 1)', //#FEF5F5
			},
			lightAccent: {
				main: 'rgba(254, 245, 245, 1)', //#FEF5F5
			},
			lightBackground: {
				main: 'rgba(250, 250, 250, 1)', // #FAFAFA
			},
		},
		components: {
			MuiButton: {
				styleOverrides: {
					contained: () => ({
						boxShadow: 'none',
						'&:hover': {
							backgroundColor: 'rgba(217, 38, 33, 1)', //#D92621
						},
						'&:focus': {
							backgroundColor: 'rgba(169, 30, 26, 1)', //#A91E1A
						},
						'&:active': {
							backgroundColor: 'rgba(169, 30, 26, 1)', //#A91E1A
						},
					}),
				},
			},
			MuiFab: {
				styleOverrides: {
					root: {
						boxShadow: 'none',
						'&:hover': {
							backgroundColor: 'rgba(217, 38, 33, 1)', //#D92621
						},
						'&:focus': {
							backgroundColor: 'rgba(169, 30, 26, 1)', //#A91E1A
						},
						'&:active': {
							backgroundColor: 'rgba(169, 30, 26, 1)', //#A91E1A
						},
					},
				},
			},
		},
	} as ThemeOptions),
);

export default ir;
